import React from 'react';
import { Link } from 'react-router-dom';
import './CourseSectionHeader.css';
import leftShadow from '../../assets/elements/titleshadowleft.png';
import rightShadow from '../../assets/elements/titleshadowright.png';

interface CourseSectionHeaderProps {
  title: string;
  link?: string;
  linkText?: string;
}

const CourseSectionHeader: React.FC<CourseSectionHeaderProps> = ({ 
  title, 
  link = "/events", 
  linkText = "See All" 
}) => {
  return (
    <div className="course-section-container-header">
      {/* Left Shadow */}
      <img src={leftShadow} alt="Left Shadow" className="title-shadow left-shadow" />

      <div className="course-section-container-courses-header">
        <h1 className="course-section-container-courses-title">{title}</h1>  
        {link && <Link className="see-all-link" to={link}>{linkText}</Link>}
      </div> 

      {/* Right Shadow */}
      <img src={rightShadow} alt="Right Shadow" className="title-shadow right-shadow" />
    </div>
  );
};

export default CourseSectionHeader;
